import React, { useEffect, useState } from 'react';

import {
  HotelDetailFeatureCategoryViewModel,
  HotelFeatureSeasonViewModel,
} from '@api/v3';
import Typography from '@components/Typography';
import Accordion from '@components/Accordion/next/Accordion';
import { Available, AvailableLimited } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { formatArrayToString } from '@utils/utils';
import { useDevice } from '@contexts/device';
import Markdown from '@components/utils/Markdown';

import Tab, { TabItem } from './Tab';
import {
  BodyContainer,
  ConditionWrapper,
  Container,
  CustomShowMoreText,
  Feature,
  FeatureGroupDescription,
  FeatureListContainer,
  NonFreeWrapper,
  ShowMoreLink,
  TabsContainer,
  TitleCondition,
} from './styled';
import {
  HONEYMOON_FEATURES_PROD_ID,
  HONEYMOON_FEATURES_STAGE_ID,
  HOTEL_FEATURES_PROD_ID,
  HOTEL_FEATURES_STAGE_ID,
  LOCATION_FEATURES_PROD_ID,
  LOCATION_FEATURES_STAGE_ID,
  PET_ACCEPTANCE_FEATURES_PROD_ID,
  PET_ACCEPTANCE_FEATURES_STAGE_ID,
  REWARD_FEATURES_PROD_ID,
  REWARD_FEATURES_STAGE_ID,
} from './helpers';
import { getSessionIcon } from './SessionIcon';
import { isBetween } from './isBetween';

const HotelFeatures = ({
  hotelFeatures,
  beginDate,
  generalConditions,
}: {
  hotelFeatures: HotelFeatureSeasonViewModel[];
  features?: Array<HotelDetailFeatureCategoryViewModel>;
  beginDate?: Date | string;
  generalConditions?: string;
}) => {
  const [selected, setselected] = useState('');

  const { isDesktop } = useDevice();

  const [featuresSelected, setfeaturesSelected] = useState('');
  const summerControl = hotelFeatures
    ?.map((item) => item.name)
    .includes('Summer');
  const winterControl = hotelFeatures
    ?.map((item) => item.name)
    .includes('Winter');
  const onTabSelect = (s: string) => {
    setselected(s);
  };

  const [featureItem, setFeatureItem] = useState(hotelFeatures);

  const renderHotelFeatureDescription2 = (description?: string) => {
    {
      return description ? (
        <CustomShowMoreText
          lines={isDesktop ? 2 : 6}
          more={<ShowMoreLink>Devamını Oku</ShowMoreLink>}
          less={<ShowMoreLink>Daha Az Göster</ShowMoreLink>}
          expanded={false}
        >
          <FeatureGroupDescription
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </CustomShowMoreText>
      ) : null;
    }
  };
  useEffect(() => {
    const newFeatures = hotelFeatures.filter(
      (item) => item.name !== 'NoSeason'
    );
    setFeatureItem(newFeatures);
    setfeaturesSelected(selected);
  }, [selected, hotelFeatures]);

  const summer = featureItem.find((item) => item.name === 'Summer');
  const winter = featureItem.find((item) => item.name === 'Winter');
  const summerStart = new Date(formatArrayToString(summer?.startDate || ''));
  const summerEnd = new Date(formatArrayToString(summer?.endDate || ''));
  const winterStart = new Date(formatArrayToString(winter?.startDate || ''));
  const winterEnd = new Date(formatArrayToString(winter?.endDate || ''));

  useEffect(() => {
    if (beginDate) {
      const sessionSummer = isBetween({
        beginDate: beginDate as Date,
        start: summerStart,
        end: summerEnd,
      });

      const sessionWinter = isBetween({
        beginDate: beginDate as Date,
        start: winterStart,
        end: winterEnd,
      });

      if (sessionSummer) {
        setselected('Summer');
      } else if (sessionWinter) {
        setselected('Winter');
      }

      if (!sessionSummer && !sessionWinter) {
        const filteredFeatures = hotelFeatures?.filter(
          (item) => item?.name !== 'NoSeason'
        );
        if (filteredFeatures?.length > 0) {
          setselected(filteredFeatures?.[0]?.name ?? '');
        }
      }
    } else {
      const filteredFeatures = hotelFeatures?.filter(
        (item) => item?.name !== 'NoSeason'
      );

      if (filteredFeatures?.length > 0) {
        if (
          filteredFeatures.filter((item) => item?.name === 'Summer')?.length > 0
        ) {
          setselected('Summer');
        } else {
          setselected(filteredFeatures?.[0]?.name ?? '');
        }
      }
    }
  }, [hotelFeatures]);

  return (
    <Container>
      {hotelFeatures?.length ? (
        summerControl || winterControl ? (
          <div>
            <TabsContainer
              style={{
                width:
                  summerControl && winterControl
                    ? '100%'
                    : isDesktop
                    ? '50%'
                    : '100%',
              }}
            >
              <Tab selected={selected} onTabSelection={onTabSelect}>
                {featureItem?.map((item, index) => (
                  <TabItem
                    key={index}
                    text={item.name || ''}
                    icon={getSessionIcon(item.name || '')}
                    select={selected}
                    control={summerControl && winterControl}
                    startDate={item.startDate || ''}
                    endDate={item.endDate || ''}
                  />
                ))}
              </Tab>
            </TabsContainer>
            {hotelFeatures?.map((item, index) =>
              item.name === featuresSelected ? (
                <div key={index}>
                  {item?.categories?.map((featureGroup) =>
                    featureGroup.features.length > 0 ||
                    featureGroup.description ? (
                      <Accordion
                        key={featureGroup.id}
                        backgroundColor='NL0'
                        bodyBackgroundColor='NL0'
                        borderRadius='8px'
                        borderColor='NL30'
                        headerFullBorder={true}
                        showBottomBorderOnOpened={false}
                        alwaysShowBottomBorder={false}
                        showBottomBorderOnClosed={true}
                        showBodyBorder={true}
                        headerPadding='16px'
                        headerContentColor='D400'
                        iconColor='D400'
                        iconSize={20}
                        contentPadding='0px'
                        label={
                          <Typography
                            variant='Title5'
                            color='D400'
                            weight='SemiBold'
                          >
                            {featureGroup.name}
                          </Typography>
                        }
                      >
                        <BodyContainer>
                          {renderHotelFeatureDescription2(
                            featureGroup.description
                          )}
                          <FeatureListContainer>
                            {featureGroup.features?.map((feat) => (
                              <Feature key={feat.name}>
                                {featureGroup.id === HOTEL_FEATURES_STAGE_ID ||
                                featureGroup.id ===
                                  HOTEL_FEATURES_PROD_ID ? null : (
                                  <CustomIcon
                                    icon={
                                      feat.charged
                                        ? AvailableLimited
                                        : Available
                                    }
                                    fontSize={20}
                                  />
                                )}

                                <Typography
                                  variant='caption2'
                                  color='D500'
                                  weight='Regular'
                                >
                                  {feat.name}
                                </Typography>
                              </Feature>
                            ))}
                          </FeatureListContainer>
                          <NonFreeWrapper>
                            {featureGroup.id === HOTEL_FEATURES_STAGE_ID ||
                            featureGroup.id === HOTEL_FEATURES_PROD_ID ||
                            featureGroup.id === HONEYMOON_FEATURES_PROD_ID ||
                            featureGroup.id === HONEYMOON_FEATURES_STAGE_ID ||
                            featureGroup.id === LOCATION_FEATURES_PROD_ID ||
                            featureGroup.id === LOCATION_FEATURES_STAGE_ID ||
                            featureGroup.id === REWARD_FEATURES_PROD_ID ||
                            featureGroup.id === REWARD_FEATURES_STAGE_ID ||
                            featureGroup.id ===
                              PET_ACCEPTANCE_FEATURES_PROD_ID ||
                            featureGroup.id ===
                              PET_ACCEPTANCE_FEATURES_STAGE_ID ||
                            featureGroup.features.length === 0 ? null : (
                              <Typography
                                variant='caption2'
                                color='O500'
                                weight='Regular'
                              >
                                ₺ 'ile belirtilen özellikler ücretlidir.
                              </Typography>
                            )}
                          </NonFreeWrapper>
                        </BodyContainer>
                      </Accordion>
                    ) : null
                  )}
                </div>
              ) : null
            )}
          </div>
        ) : (
          <div>
            <Typography variant='Title4' color='D400' weight='Bold'>
              Otel Özellikleri
            </Typography>
            {hotelFeatures?.map((item) =>
              item.name === 'NoSeason' ? (
                <div key={item.id}>
                  {item?.categories?.map((featureGroup) =>
                    featureGroup.features.length > 0 ||
                    featureGroup.description ? (
                      <Accordion
                        key={featureGroup.id}
                        backgroundColor='NL0'
                        bodyBackgroundColor='NL0'
                        borderRadius='8px'
                        borderColor='NL30'
                        headerFullBorder={true}
                        showBottomBorderOnOpened={false}
                        alwaysShowBottomBorder={false}
                        showBottomBorderOnClosed={true}
                        showBodyBorder={true}
                        headerPadding='16px'
                        headerContentColor='D400'
                        iconColor='D400'
                        iconSize={20}
                        contentPadding='0px'
                        label={
                          <Typography
                            variant='Title5'
                            color='D400'
                            weight='SemiBold'
                          >
                            {featureGroup.name}
                          </Typography>
                        }
                      >
                        <BodyContainer>
                          {renderHotelFeatureDescription2(
                            featureGroup.description
                          )}
                          <FeatureListContainer>
                            {featureGroup?.features?.map((feat) => (
                              <Feature key={feat.name}>
                                {featureGroup.id === HOTEL_FEATURES_STAGE_ID ||
                                featureGroup.id ===
                                  HOTEL_FEATURES_PROD_ID ? null : (
                                  <CustomIcon
                                    icon={
                                      feat.charged
                                        ? AvailableLimited
                                        : Available
                                    }
                                    fontSize={20}
                                  />
                                )}

                                <Typography
                                  variant='caption2'
                                  color='D500'
                                  weight='Regular'
                                >
                                  {feat.name}
                                </Typography>
                              </Feature>
                            ))}
                          </FeatureListContainer>
                          <NonFreeWrapper>
                            {featureGroup.id === HOTEL_FEATURES_STAGE_ID ||
                            featureGroup.id === HOTEL_FEATURES_PROD_ID ||
                            featureGroup.id === HONEYMOON_FEATURES_PROD_ID ||
                            featureGroup.id === HONEYMOON_FEATURES_STAGE_ID ||
                            featureGroup.id === LOCATION_FEATURES_PROD_ID ||
                            featureGroup.id === LOCATION_FEATURES_STAGE_ID ||
                            featureGroup.id === REWARD_FEATURES_PROD_ID ||
                            featureGroup.id === REWARD_FEATURES_STAGE_ID ||
                            featureGroup.id ===
                              PET_ACCEPTANCE_FEATURES_PROD_ID ||
                            featureGroup.id ===
                              PET_ACCEPTANCE_FEATURES_STAGE_ID ||
                            featureGroup.features.length === 0 ? null : (
                              <Typography
                                variant='caption2'
                                color='O500'
                                weight='Regular'
                              >
                                ₺ 'ile belirtilen özellikler ücretlidir.
                              </Typography>
                            )}
                          </NonFreeWrapper>
                        </BodyContainer>
                      </Accordion>
                    ) : null
                  )}
                </div>
              ) : null
            )}
          </div>
        )
      ) : null}
      {generalConditions ? (
        <ConditionWrapper isMargin={hotelFeatures?.length ? true : false}>
          <TitleCondition>
            <Typography
              variant={isDesktop ? 'Title4' : 'caption'}
              color='D400'
              weight='Bold'
            >
              Genel Şartlar
            </Typography>
          </TitleCondition>
          <Markdown text={generalConditions || ''} />
        </ConditionWrapper>
      ) : null}
    </Container>
  );
};

export default HotelFeatures;
